import type { ReactNode } from "react";

/** Centred message block of the error and not-found pages: a title, a sentence, and the way out. */
export function StatusPage({ title, children, actions }: { title: ReactNode; children?: ReactNode; actions?: ReactNode }) {
    return (
        <div className="mx-auto flex min-h-[50vh] w-full max-w-xl flex-col justify-center gap-4 px-4 py-10">
            <h1 className="text-2xl font-bold tracking-tight text-foreground sm:text-3xl">{title}</h1>
            {children ? <div className="text-muted-foreground">{children}</div> : null}
            {actions ? <div className="flex flex-wrap items-center gap-3">{actions}</div> : null}
        </div>
    );
}
